import client from '../client'

export default {
  async getChainDepositAddress(params: { chain_id: string }): Promise<{ address: string }> {
    const { data } = await client.get(`/chain/${params.chain_id}/address`)
    return data
  },
}
